<template>
    <div class="list-item__actions" @click.prevent>
        <p>
            <template v-if="advert.is_expired">
                Expired
            </template>
            <template v-else>
                Expiring in <strong>{{ advert.expires_days }} days</strong>
            </template>
            <br>
            Status: <strong>{{ advert.status_formatted }}</strong><br>
            <strong>{{ advert.admin_status_formatted }}</strong>
        </p>

        <p>
            Views: <strong>{{ advert.views_count }}</strong> <br>
            Favourites: <strong>{{ advert.favorites_count }}</strong>
        </p>

        <p class="btn-container" v-if="!advert.integration">
            <a
                v-if="advert.is_listed"
                class="btn btn--xs btn--secondary"
                :href="advert.ad_url"
                target="_blank"
                @click.stop
            >
                View
            </a>
            <a
                v-else
                class="btn btn--xs btn--secondary"
                :href="advert.ad_preview_url"
                target="_blank"
                @click.stop
            >
                Preview
            </a>
            <a
                v-if="!advert.is_published"
                class="btn btn--xs btn--primary"
                @click.prevent="publishMyAd"
            >
                Publish
            </a>
            <a
                v-if="hasRenewButton"
                class="btn btn--xs btn--primary"
                @click.prevent="renewMyAd"
            >
                Renew
            </a>
            <a
                v-if="user && !user.is_individual_tenant && advert.is_published"
                class="btn btn--xs btn--dark-empty"
                @click.prevent="showLetAgreedModal = true"
            >
                Let Agreed
            </a>
            <a
                v-if="advert.is_published"
                class="btn btn--xs btn--dark-empty"
                @click.prevent="showUnpublishModal = true"
            >
                Unpublish
            </a>
            <a
                class="btn btn--xs btn--dark-empty"
                :href="advert.edit_url"
                @click.stop
            >
                Edit
            </a>
            <a
                v-if="!advert.is_published"
                class="btn btn--xs btn--dark-empty"
                @click.prevent="showDeleteModal = true"
            >
                Delete
            </a>
            <!-- <a
                v-if="hasPostedBy && user && user.is_company"
                class="btn btn--xs btn--dark-empty"
                @click.prevent="showMoveToAnotherUserModal = true"
            >
                Move to another agent
            </a> -->
        </p>

        <p class="list-item__posted-by" v-if="hasPostedBy">
            Posted by: <strong>{{ advert.contact.public_name }}</strong>
        </p>

        <p class="list-item__integration" v-if="advert.integration">
            <img :src="advert.integration.provider_icon_url" width="auto" height="20" :alt="advert.integration.provider_name" />
            <small class="text-muted">ID: {{ advert.integration.provider_uuid }}</small>
        </p>

        <UnpublishModal
            :show-modal="showUnpublishModal"
            :ad="ad"
            @close="showUnpublishModal = false"
            @unpublished="unpublishMyAd"
        />

        <LetAgreedModal
            v-if="user && !user.is_individual_tenant"
            :show-modal="showLetAgreedModal"
            :ad="ad"
            @close="showLetAgreedModal = false"
            @let-agreed="letAgreedMyAd"
        />

        <MoveToAnotherUserModal
            :show-modal="showMoveToAnotherUserModal"
            :ad="ad"
            :agents="agents"
            @close="showMoveToAnotherUserModal = false"
            @move="moveMyAd"
        />

        <DeleteModal
            :show-modal="showDeleteModal"
            :ad="ad"
            @close="showDeleteModal = false"
            @deleted="deleteMyAd"
        />

        <div class="list-item__btns">
            <!-- <a href="" class="btn btn--round"><span>&bull;&bull;&bull;</span></a> -->
            <input
                type="checkbox"
                class="checkbox-large"
                v-model="isChecked"
                @click.stop="$emit('selected', advert)"
            >
        </div>
    </div>

</template>

<script>
import DeleteModal from '@components/AdCard/partials/DeleteModal.vue';
import LetAgreedModal from '@components/AdCard/partials/LetAgreedModal.vue';
import MoveToAnotherUserModal from '@components/AdCard/partials/MoveToAnotherUserModal.vue';
import UnpublishModal from '@components/AdCard/partials/UnpublishModal.vue';
import { mapActions, mapState } from 'vuex';

export default {
    inject: ['$validator'],
    components: {
        UnpublishModal,
        MoveToAnotherUserModal,
        LetAgreedModal,
        DeleteModal,
    },
    props: {
        ad: {
            type: Object,
            required: true,
        },
        agents: {
            type: Array,
            required: true,
        },
        hasRenewButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasPostedBy: {
            type: Boolean,
            required: false,
            default: false,
        },
        isSelected: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            advert: this.ad,
            isChecked: false,
            showUnpublishModal: false,
            showDeleteModal: false,
            showMoveToAnotherUserModal: false,
            showLetAgreedModal: false,
        };
    },
    computed: {
        ...mapState('user', ['user']),
    },
    watch: {
        isSelected(value) {
            this.isChecked = value;
        },
        ad(value) {
            this.advert = value;
        },
    },
    methods: {
        ...mapActions('user', [
            'deleteAd',
            'publishAd',
            'unpublishAd',
            'letAgreedAd',
            'renewAd',
            'moveAd',
        ]),
        publishMyAd() {
            this.publishAd(this.advert.slug)
                .then((data) => {
                    this.advert = data;
                    this.$emit('updated', data);
                    window.showToastSuccess('Successfully published');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 403) {
                        if (error.response.data.message.search('unverified_phone_number_on_agent') !== -1) {
                            const message = error.response.data.message.replace('unverified_phone_number_on_agent ', '');
                            window.showError('Can\'t publish advert', message);
                        } else if (error.response.data.message.search('unverified_phone_number') !== -1) {
                            this.$root.$emit('open-start-phone-verification-modal');
                        } else if (error.response.data.message.search('advert_limit_reached') !== -1) {
                            const message = error.response.data.message.replace('advert_limit_reached ', '');
                            this.$root.$emit('open-advert-limit-reached-modal', message);
                        } else if (error.response.data.message.search('cannot_publish_ad_type') !== -1) {
                            const message = error.response.data.message.replace('cannot_publish_ad_type ', '');
                            window.showError('Can\'t publish advert', message);
                        }
                    }
                });
        },
        async renewMyAd() {
            const ad = await this.renewAd(this.advert.slug);
            this.advert = ad;
            this.$emit('updated', ad);
            window.showToastSuccess('Successfully renewed');
        },
        async unpublishMyAd(event) {
            const ad = await this.unpublishAd(event);
            this.advert = ad;
            this.$emit('updated', ad);
            window.showToastSuccess('Successfully unpublished');
        },
        async letAgreedMyAd(event) {
            const ad = await this.letAgreedAd(event);
            this.advert = ad;
            this.$emit('updated', ad);
            window.showToastSuccess('OK');
        },
        async deleteMyAd(event) {
            const ad = await this.deleteAd(event);
            this.advert = ad;
            this.$emit('deleted', ad);
            window.showToastSuccess('Successfully deleted.');
        },
        async moveMyAd(event) {
            const ad = await this.moveAd(event);
            this.advert = ad;
            this.$emit('updated', ad);
            this.showMoveToAnotherUserModal = false;
            window.showToastSuccess('Successfully moved');
        },
    },
};
</script>
